module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spotlight relative"
  }, [_c('div', {
    directives: [{
      name: "touch",
      rawName: "v-touch",
      value: ({
        up: function () { return _vm.swipe(true); },
        down: function () { return _vm.swipe(false); },
      }),
      expression: "{\n      up: () => swipe(true),\n      down: () => swipe(false),\n    }"
    }],
    staticClass: "spotlight__image"
  }, [(_vm.currentIndex == 0) ? _c('img', {
    attrs: {
      "src": require("../../assets/mobile/spotlight.gif")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentIndex == 1) ? _c('img', {
    attrs: {
      "src": require("../../assets/mobile/spotlight_1.gif")
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../assets/mobile/spotlight_2.gif")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "spotlight__content full-width absolute"
  }, [_c('div', {
    staticClass: "display-flex justify-space-between align-center"
  }, [_c('img', {
    attrs: {
      "src": require('@/assets/ys_logo_primary-black.svg'),
      "width": "100"
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/')
      }
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "spotlight__action display-flex flex-column align-center"
  }, [_c('div', {
    staticClass: "display-flex flex-column justify-center mb-3",
    on: {
      "click": function($event) {
        _vm.isSend = true
      }
    }
  }, [_c('img', {
    staticClass: "mb-1",
    attrs: {
      "src": require("../../assets/mobile/icon/message.svg"),
      "width": "19",
      "height": "19"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-poppins-14 text-white"
  }, [_vm._v("23")])]), _vm._v(" "), _c('div', {
    staticClass: "display-flex flex-column justify-center mb-3",
    on: {
      "click": function($event) {
        _vm.isComment = true
      }
    }
  }, [_c('img', {
    staticClass: "mb-1",
    attrs: {
      "src": require("../../assets/mobile/icon/f-chat.svg"),
      "width": "20",
      "height": "20"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-poppins-14 text-white"
  }, [_vm._v("1.2k")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('Footer')], 1), _vm._v(" "), _c('v-bottom-sheet', {
    attrs: {
      "hide-overlay": ""
    },
    model: {
      value: (_vm.isComment),
      callback: function($$v) {
        _vm.isComment = $$v
      },
      expression: "isComment"
    }
  }, [_c('v-list', {
    staticClass: "px-4"
  }, [_c('v-subheader', {
    staticClass: "text-inter-14 font-weight-600 mb-3 justify-center"
  }, [_vm._v("\n        Comments\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "display-flex gap-10 mb-5 pb-5"
  }, [_c('img', {
    staticClass: "rounded",
    attrs: {
      "src": require("../../assets/mobile/notification_2.png"),
      "width": 44,
      "height": 44
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "text-inter-14"
  }, [_c('span', {
    staticClass: "font-weight-600"
  }, [_vm._v(" superman10 ")]), _vm._v(" "), _c('span', {
    staticClass: "font-weight-500 text-grey-3"
  }, [_vm._v("12s")])]), _vm._v(" "), _c('div', {
    staticClass: "text-inter-14 font-weight-500"
  }, [_vm._v("\n            I really want to do those things a thing when we we see a thing to\n            do a thing when really really see the thing!\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "display-flex align-center gap-10 my-5 pt-5"
  }, [_c('img', {
    staticClass: "rounded",
    attrs: {
      "src": require("../../assets/mobile/notification_2.png"),
      "width": 44,
      "height": 44
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "input-comment full-width pa-2",
    attrs: {
      "type": "text",
      "placeholder": "Say something!"
    }
  })])], 1)], 1), _vm._v(" "), _c('v-bottom-sheet', {
    attrs: {
      "hide-overlay": ""
    },
    model: {
      value: (_vm.isSend),
      callback: function($$v) {
        _vm.isSend = $$v
      },
      expression: "isSend"
    }
  }, [_c('v-list', {
    staticClass: "px-4"
  }, [_c('div', {
    staticClass: "display-flex align-center input-search px-2 my-4"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/mobile/icon/search.svg"),
      "width": "20",
      "height": "20"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "full-width px-2 input-search__input",
    attrs: {
      "type": "text",
      "placeholder": "Search people"
    }
  })]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((4), function(i) {
    return _c('v-flex', {
      key: i,
      attrs: {
        "d-flex": "",
        "xs4": "",
        "mb-3": ""
      }
    }, [_c('div', {
      staticClass: "display-flex flex-column align-center justify-center gap-4"
    }, [_c('img', {
      staticClass: "rounded",
      attrs: {
        "src": require("../../assets/mobile/notification_2.png"),
        "width": 44,
        "height": 44
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text-inter-14 font-weight-500"
    }, [_vm._v("TREV")])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "input-send"
  }, [_c('input', {
    staticClass: "full-width px-2 input-send__input",
    attrs: {
      "type": "text",
      "placeholder": "Write a message..."
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "input-send__btn text-inter-12 text-white"
  }, [_vm._v("\n          Send seperately\n        ")])], 1)], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "camera"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/mobile/icon/camera.svg"),
      "width": "19",
      "height": "19"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex flex-column justify-center mb-3"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/mobile/icon/dot.svg"),
      "width": "24",
      "height": "24"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex flex-column justify-center"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/mobile/music.svg"),
      "width": "34",
      "height": "34"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex justify-space-between align-center spotlight__user"
  }, [_c('div', {
    staticClass: "display-flex align-center gap-8"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/mobile/user.svg"),
      "width": "60",
      "height": "60"
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "display-flex gap-4 align-center"
  }, [_c('span', {
    staticClass: "text-poppins-18 text-white"
  }, [_vm._v(" Salva ")]), _vm._v(" "), _c('img', {
    staticClass: "max-full-width",
    attrs: {
      "src": require("../../assets/mobile/icon/check-circle.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-poppins-15 text-white"
  }, [_vm._v("12,392 views")])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-follow display-flex justify-center align-center"
  }, [_c('div', {
    staticClass: "text-poppins-13 text-black font-weight-600"
  }, [_vm._v("Follow")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bc8f25f","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/new-mobile/spotlight.vue
// module id = 1717
// module chunks = 180